module.exports = __webpack_public_path__ + "img/payment.847a0bcb.png";